import { useState, useEffect } from 'react';
import styles from './styles/nav.module.css';
import useMediaQuery from '../../hooks/useMediaQuery';
import logo from '../../assets/images/DtpLogoSmall.webp';
import { Bars3Icon, XMarkIcon, ChevronDoubleDownIcon, ChevronDoubleUpIcon } from '@heroicons/react/24/solid';
import { useAuth } from '../../contexts/AuthContext';
import { useLocation } from "react-router-dom";

const NavBar = () => {

  const isAboveMediumScreens = useMediaQuery("(min-width: 1000px)");
  const [isMenuToggled, setIsMenuToggled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { currentUser } = useAuth();
  const [currentUrl, setCurrentUrl] = useState('');

  const location = useLocation();
  useEffect(() => {
    const currentPage = window.location;
    setCurrentUrl(currentPage.pathname.toLowerCase());
    console.log('Page changed to:', location.pathname);
  }, [location]);

  useEffect(() => {
    const handleClickOutside = () => {
      if (isMenuToggled) {
        setIsMenuToggled(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isMenuToggled]);

  useEffect(() => {
    const handleClickOutside = () => {
      if (isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isOpen]);


  return (
    <>
      {currentUrl !== '/survey' &&
        <nav>
          <div className={styles.navMainContainer}>
            {!isAboveMediumScreens && <a href="/"><img src={logo} alt="logo" className={styles.logo} /></a>}
            {isAboveMediumScreens ?
              <div className={styles.desktopNavContainer}>
                <a href="/"><img src={logo} alt="logo" className={styles.logo} /></a>
                <div className={styles.featureMenuContainer} onClick={(e) => {
                  e.stopPropagation();
                  setIsOpen((prev) => !prev)
                }}>
                  <p className={styles.paragraph}>Device Tracker Plus is for...
                    {
                      !isOpen ?
                        (<ChevronDoubleDownIcon className={styles.featureIcons} />) :
                        (<ChevronDoubleUpIcon className={styles.featureIcons} />)
                    }
                  </p>
                  {isOpen && (
                    <div className={styles.dropDownContainer}>
                      <div className={styles.dropDownItem}>
                        <a href={'/familyTracking'} className={styles.paragraph}>...Families</a>
                      </div>
                      <div className={styles.dropDownItem}>
                        <a className={styles.paragraph} href={'/kids-tracking'}>...Parents</a>
                      </div>
                      <div className={styles.dropDownItem}>
                        <a className={styles.paragraph} href={'/find-my-friends'}>...Friends</a>
                      </div>
                      <div className={styles.dropDownItem}>
                        <a className={styles.paragraph} href={'/couples-location-sharing'}>...Couples</a>
                      </div>
                      <div className={styles.dropDownItem}>
                        <a className={styles.paragraph} href={'/carer-tracking'}>...Carers</a>
                      </div>
                      <div className={styles.dropDownItem}>
                        <a className={styles.paragraph} href={'/travel-safety'}>...Travel</a>
                      </div>
                    </div>
                  )}
                </div>
                <ul className={styles.desktopNavList}>
                  <li>
                    <a className={styles.link} href={'/faqs'}>FAQ</a>
                  </li>
                  <li>
                    <a className={styles.link} href={'/help'}>Help</a>
                  </li>
                  {!currentUser ?
                    < li >
                      <a className={styles.loginButton} href={'/login'}>Login</a>
                    </li>
                    :
                    < li >
                      <a className={styles.link} href={'/dashboard'}>Dashboard</a>
                    </li>
                  }
                </ul>
              </div>
              :
              <div className={styles.navMobileButton} id="navMobile" title="navMobile"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsMenuToggled(!isMenuToggled)
                }}
              >
                {
                  !isMenuToggled ? <Bars3Icon className={styles.mobileMenuIcon} /> : <XMarkIcon className={styles.mobileMenuIcon} />
                }
              </div>
            }
          </div>
          {/* Mobile Menu */}
          {
            !isAboveMediumScreens && isMenuToggled && (
              <div className={styles.mobileNav}>
                <ul className={styles.mobileNavMenuList}>
                  <li >
                    <a className={styles.mobileNavItem} href={'/'}>Home</a>
                  </li>
                  <li
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsOpen((prev) => !prev)
                    }}
                  >
                    <div className={styles.mobileFeatureMenuContainer}>
                      <p className={styles.mobileNavItem}>DTP App is for... {
                        !isOpen ?
                          (<ChevronDoubleDownIcon className={styles.featureIcons} />) :
                          (<ChevronDoubleUpIcon className={styles.featureIcons} />)
                      }</p>
                      {isOpen && (
                        <div className={styles.mobileDropDownContainer}>
                          <div className={styles.mobileDropDownItem}>
                            <a className={styles.mobileNavItem} href={'/familyTracking'}>...Families</a>
                          </div>
                          <div className={styles.mobileDropDownItem}>
                            <a className={styles.mobileNavItem} href={'/kids-tracking'}>...Parents</a>
                          </div>
                          <div className={styles.mobileDropDownItem}>
                            <a className={styles.mobileNavItem} href={'/find-my-friends'}>...Friends</a>
                          </div>
                          <div className={styles.mobileDropDownItem}>
                            <a className={styles.mobileNavItem} href={'/couples-location-sharings'}>...Couples</a>
                          </div>
                          <div className={styles.mobileDropDownItem}>
                            <a className={styles.mobileNavItem} href={'/carer-tracking'}>...Carers</a>
                          </div>
                          <div className={styles.mobileDropDownItem}>
                            <a className={styles.mobileNavItem} href={'/travel-safety'}>...Travel</a>
                          </div>
                        </div>
                      )}
                    </div>
                  </li>
                  <li >
                    <a href={'/whoWeAre'} className={styles.mobileNavItem}>Who we are</a>
                  </li>
                  <li >
                    <a href={'/faqs'} className={styles.mobileNavItem} >FAQ</a>
                  </li>
                  <li >
                    <a href={'/help'} className={styles.mobileNavItem}>Help</a>
                  </li>
                  {!currentUser &&
                    <li className={styles.mobileButtonContainer}>
                      <a className={styles.loginButton} href={'/Login'}>Login</a>
                    </li>
                  }
                </ul>
              </div>
            )
          }

        </nav >
      }
    </>
  );
}

export default NavBar;